import { render } from "./AposTiptapMarks.vue?vue&type=template&id=037481d1&scoped=true"
import script from "./AposTiptapMarks.vue?vue&type=script&lang=js"
export * from "./AposTiptapMarks.vue?vue&type=script&lang=js"

import "./AposTiptapMarks.vue?vue&type=style&index=0&id=037481d1&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-037481d1"],['__file',"rich-text-widget/ui/apos/components/AposTiptapMarks.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "037481d1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('037481d1', __exports__)) {
    api.reload('037481d1', __exports__)
  }
  
  module.hot.accept("./AposTiptapMarks.vue?vue&type=template&id=037481d1&scoped=true", () => {
    api.rerender('037481d1', render)
  })

}


export default __exports__